import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from 'react-redux'
import { store } from './lib/redux/store';

import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'


import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-quartz.css'
import 'react-tooltip/dist/react-tooltip.css'


import 'react-quill/dist/quill.snow.css';

import 'react-datetime-picker/dist/DateTimePicker.css'
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css'
import 'react-clock/dist/Clock.css'

// Create a client with optimized settings for better performance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10, 
      cacheTime: 1000 * 60 * 30, 
      refetchOnWindowFocus: false, 
      refetchOnMount: false, 
      refetchOnReconnect: false, 
      keepPreviousData: true, 
      retry: (failureCount, error) => {
     
        if (!error?.response) {
          return failureCount < 2
        }
        return false
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      retry: false, // Don't retry mutations by default
    }
  }
})



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <Router>
        <App />
      </Router>
    </QueryClientProvider>
  </Provider>

);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
